
import api from 'frontend/api';

export default {
	async fetchCheckoutSummary({ state, commit })
	{
		var params = {}, result;

		if (state.summary.total > 0) {
			if (state.order.paymentMethod.is_new)
			{
				params = {
					country: state.order.paymentMethod.billing_addr.country || '',
					region: state.order.paymentMethod.billing_addr.region || '',
				};
			}
			else
			{
				params = {
					country: state.order.paymentMethod.country || '',
					region: state.order.paymentMethod.region || '',
				};
			}
		}
		else {
			params = {
				country: '',
				region: '',
			};
		}

		result = await api.get('/checkout/summary', { params });

		commit('updateSummary', result.data.summary);
	},

	async submitOrder({ state })
	{
		var result, payload;

		// setup parameters
		payload = {
			shipping_address: state.order.shippingAddress,
			pick_up_in_store: state.order.pickUpInStore,
		}

		if (state.summary.total > 0 && state.order.paymentMethod.is_new)
		{
			payload.payment_method = { ...state.order.paymentMethod };
			payload.payment_method_id = 0;
		}
		else if (state.summary.total > 0)
		{
			payload.payment_method_id = state.order.paymentMethod.id;
		}

		// send order to server
		result = await api.post('/checkout/submit_order', payload);
		return result.data;
	}
}